<script setup lang="ts">
defineProps<{ to: string }>()
</script>

<template>
  <router-link :to="to" class="brand">
    <span class="brand-badge">
      <svg viewBox="0 0 64 64" width="20" height="20" fill="none" aria-hidden="true">
        <g stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M 16 27 C 16 18, 26 14, 32 6 C 38 14, 48 18, 48 27 L 48 46 L 32 56 L 16 46 Z" />
          <path d="M 16 27 L 32 36 L 48 27" />
          <path d="M 32 36 L 32 56" />
        </g>
      </svg>
    </span>
    <span class="brand-text">Bimdrop</span>
  </router-link>
</template>

<style scoped>
.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  text-decoration: none;
  color: var(--text);
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.brand-badge {
  width: 30px;
  height: 30px;
  border-radius: 9px;
  display: grid;
  place-items: center;
  color: #fff;
  background: var(--accent-gradient);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.25), 0 4px 14px -4px rgba(59, 130, 246, 0.6);
}

@media (max-width: 560px) {
  .brand-text {
    display: none;
  }
}
</style>
